export const PLAY_LABEL_PROPERTIES = [  { key: "season", type: "Long" },
  { key: "week", type: "Long" },
  { key: "season_type", type: "String" },
  { key: "passing_yards", type: "Long" },
  { key: "rushing_yards", type: "Long" },
  { key: "vegas_wpa", type: "Double" },
  { key: "time", type: "String" },
  { key: "comp_air_epa", type: "Double" },
  { key: "tackle_with_assist", type: "Double" },
  { key: "offense_players", type: "String" },
  { key: "away_score", type: "Long" },
  { key: "fumble_not_forced", type: "Double" },
  { key: "old_game_id_x", type: "Long" },
  { key: "game_half", type: "String" },
  { key: "assist_tackle", type: "Double" },
  { key: "total_away_raw_yac_epa", type: "Double" },
  { key: "tackle_for_loss_1_player_id", type: "String" },
  { key: "qb_hit", type: "Double" },
  { key: "assist_tackle_1_player_name", type: "String" },
  { key: "assist_tackle_3_player_name", type: "String" },
  { key: "fumble_recovery_2_yards", type: "Long" },
  { key: "two_point_conv_result", type: "String" },
  { key: "sp", type: "Double" },
  { key: "defensive_extra_point_conv", type: "Double" },
  { key: "receiver_jersey_number", type: "Long" },
  { key: "touchdown", type: "Double" },
  { key: "total_home_rush_epa", type: "Double" },
  { key: "home_coach", type: "String" },
  { key: "total_away_pass_wpa", type: "String" },
  { key: "total_away_raw_air_wpa", type: "Double" },
  { key: "solo_tackle_2_player_name", type: "String" },
  { key: "drive_yards_penalized", type: "Long" },
  { key: "punt_fair_catch", type: "Double" },
  { key: "play_id", type: "Long" },
  { key: "rusher_jersey_number", type: "Long" },
  { key: "opp_fg_prob", type: "Double" },
  { key: "half_sack_1_player_id", type: "String" },
  { key: "time_to_throw", type: "Double" },
  { key: "assist_tackle_4_team", type: "String" },
  { key: "tackled_for_loss", type: "Double" },
  { key: "total_home_pass_epa", type: "Double" },
  { key: "drive_quarter_start", type: "Long" },
  { key: "drive_quarter_end", type: "Long" },
  { key: "kickoff_attempt", type: "Double" },
  { key: "punt_downed", type: "Double" },
  { key: "players_on_play", type: "String" },
  { key: "down", type: "Long" },
  { key: "total_home_score", type: "Long" },
  { key: "receiver_player_id", type: "String" },
  { key: "total_away_raw_yac_wpa", type: "Double" },
  { key: "half_sack_2_player_name", type: "String" },
  { key: "punt_inside_twenty", type: "Double" },
  { key: "play_type_nfl", type: "String" },
  { key: "timeout", type: "Double" },
  { key: "fumble_recovery_1_player_id", type: "String" },
  { key: "total_away_comp_air_epa", type: "Double" },
  { key: "total_away_epa", type: "Double" },
  { key: "pass_oe", type: "Double" },
  { key: "rusher", type: "String" },
  { key: "return_touchdown", type: "Double" },
  { key: "series", type: "Long" },
  { key: "drive_play_count", type: "Long" },
  { key: "solo_tackle_1_team", type: "String" },
  { key: "punter_player_name", type: "String" },
  { key: "air_wpa", type: "Double" },
  { key: "qb_dropback", type: "Double" },
  { key: "fixed_drive", type: "Long" },
  { key: "ngs_air_yards", type: "Double" },
  { key: "lateral_recovery", type: "Double" },
  { key: "no_huddle", type: "Double" },
  { key: "tackle_for_loss_1_player_name", type: "String" },
  { key: "fantasy_player_id", type: "String" },
  { key: "fumble_recovery_2_player_name", type: "String" },
  { key: "assist_tackle_1_team", type: "String" },
  { key: "penalty_player_name", type: "String" },
  { key: "fumbled_1_team", type: "String" },
  { key: "blocked_player_id", type: "String" },
  { key: "roof", type: "String" },
  { key: "yac_wpa", type: "Double" },
  { key: "kicker_player_name", type: "String" },
  { key: "fumble", type: "Double" },
  { key: "home_team", type: "String" },
  { key: "solo_tackle", type: "Double" },
  { key: "offense_personnel", type: "String" },
  { key: "assist_tackle_3_player_id", type: "String" },
  { key: "total", type: "Long" },
  { key: "xyac_fd", type: "Double" },
  { key: "half_seconds_remaining", type: "Long" },
  { key: "kick_distance", type: "Long" },
  { key: "punt_out_of_bounds", type: "Double" },
  { key: "fumble_forced", type: "Double" },
  { key: "defensive_two_point_attempt", type: "Double" },
  { key: "pass_defense_2_player_id", type: "String" },
  { key: "solo_tackle_1_player_name", type: "String" },
  { key: "penalty", type: "Double" },
  { key: "name_player_gsis_id", type: "String" },
  { key: "old_game_id_y", type: "Long" },
  { key: "replay_or_challenge_result", type: "String" },
  { key: "rusher_player_id", type: "String" },
  { key: "yards_gained", type: "Long" },
  { key: "total_home_epa", type: "Double" },
  { key: "total_home_comp_yac_wpa", type: "Double" },
  { key: "total_home_comp_air_wpa", type: "Double" },
  { key: "comp_yac_wpa", type: "Double" },
  { key: "name", type: "String" },
  { key: "forced_fumble_player_2_player_id", type: "String" },
  { key: "punt_blocked", type: "Double" },
  { key: "xyac_median_yardage", type: "Double" },
  { key: "run_gap", type: "String" },
  { key: "extra_point_attempt", type: "Double" },
  { key: "fumble_recovery_2_team", type: "String" },
  { key: "receiving_yards", type: "Long" },
  { key: "kickoff_downed", type: "Double" },
  { key: "forced_fumble_player_1_team", type: "String" },
  { key: "total_line", type: "Double" },
  { key: "kickoff_returner_player_id", type: "String" },
  { key: "posteam_timeouts_remaining", type: "Long" },
  { key: "kicker_player_id", type: "String" },
  { key: "passer_player_id", type: "String" },
  { key: "safety_player_id", type: "String" },
  { key: "run_location", type: "String" },
  { key: "lateral_receiver_player_name", type: "String" },
  { key: "first_down_penalty", type: "Double" },
  { key: "id", type: "String" },
  { key: "own_kickoff_recovery_player_name", type: "String" },
  { key: "series_success", type: "Double" },
  { key: "first_down", type: "Double" },
  { key: "half_sack_2_player_id", type: "String" },
  { key: "possession_team", type: "String" },
  { key: "punter_player_id", type: "String" },
  { key: "penalty_yards", type: "Long" },
  { key: "rusher_player_name", type: "String" },
  { key: "fantasy_id", type: "String" },
  { key: "yac_epa", type: "Double" },
  { key: "fumbled_1_player_id", type: "String" },
  { key: "home_score", type: "Long" },
  { key: "own_kickoff_recovery", type: "Double" },
  { key: "posteam", type: "String" },
  { key: "quarter_end", type: "Double" },
  { key: "total_away_score", type: "Long" },
  { key: "away_coach", type: "String" },
  { key: "pass", type: "Double" },
  { key: "air_epa", type: "Double" },
  { key: "end_clock_time", type: "String" },
  { key: "lateral_rusher_player_name", type: "String" },
  { key: "result", type: "Long" },
  { key: "penalty_type", type: "String" },
  { key: "passer_id", type: "String" },
  { key: "third_down_failed", type: "Double" },
  { key: "qb_hit_1_player_id", type: "String" },
  { key: "wp", type: "Double" },
  { key: "location", type: "String" },
  { key: "td_player_name", type: "String" },
  { key: "success", type: "Double" },
  { key: "sack_player_id", type: "String" },
  { key: "game_seconds_remaining", type: "Long" },
  { key: "nflverse_game_id", type: "String" },
  { key: "total_away_raw_air_epa", type: "Double" },
  { key: "safety_prob", type: "String" },
  { key: "pass_attempt", type: "Double" },
  { key: "return_yards", type: "Long" },
  { key: "opp_td_prob", type: "Double" },
  { key: "fumbled_2_team", type: "String" },
  { key: "qb_hit_1_player_name", type: "String" },
  { key: "surface", type: "String" },
  { key: "wpa", type: "Double" },
  { key: "tackle_with_assist_1_team", type: "String" },
  { key: "defteam_timeouts_remaining", type: "Long" },
  { key: "lateral_return", type: "Double" },
  { key: "route", type: "String" },
  { key: "play_deleted", type: "Double" },
  { key: "yardline_100", type: "Long" },
  { key: "vegas_wp", type: "Double" },
  { key: "xpass", type: "Double" },
  { key: "field_goal_result", type: "String" },
  { key: "solo_tackle_2_player_id", type: "String" },
  { key: "total_away_comp_air_wpa", type: "Double" },
  { key: "first_down_pass", type: "Double" },
  { key: "own_kickoff_recovery_td", type: "Double" },
  { key: "drive", type: "Long" },
  { key: "defenders_in_box", type: "Double" },
  { key: "assist_tackle_3_team", type: "String" },
  { key: "special", type: "Double" },
  { key: "kickoff_inside_twenty", type: "Double" },
  { key: "fumbled_2_player_id", type: "String" },
  { key: "defense_personnel", type: "String" },
  { key: "special_teams_play", type: "Double" },
  { key: "defense_coverage_type", type: "String" },
  { key: "stadium", type: "String" },
  { key: "lateral_rusher_player_id", type: "String" },
  { key: "assist_tackle_4_player_id", type: "String" },
  { key: "passer_player_name", type: "String" },
  { key: "drive_real_start_time", type: "String" },
  { key: "pass_defense_1_player_name", type: "String" },
  { key: "time_of_day", type: "String" },
  { key: "yrdln", type: "String" },
  { key: "blocked_player_name", type: "String" },
  { key: "drive_start_transition", type: "String" },
  { key: "n_offense", type: "Double" },
  { key: "drive_end_yard_line", type: "String" },
  { key: "half_sack_1_player_name", type: "String" },
  { key: "lateral_kickoff_returner_player_name", type: "String" },
  { key: "interception_player_name", type: "String" },
  { key: "assist_tackle_1_player_id", type: "String" },
  { key: "assist_tackle_2_team", type: "String" },
  { key: "yards_after_catch", type: "Long" },
  { key: "fantasy", type: "String" },
  { key: "weather", type: "String" },
  { key: "side_of_field", type: "String" },
  { key: "lateral_rush", type: "Double" },
  { key: "passer", type: "String" },
  { key: "spread_line", type: "Double" },
  { key: "kickoff_fair_catch", type: "Double" },
  { key: "fumble_recovery_1_team", type: "String" },
  { key: "epa", type: "Double" },
  { key: "pass_length", type: "String" },
  { key: "xyac_mean_yardage", type: "Double" },
  { key: "defteam_score_post", type: "Long" },
  { key: "start_time", type: "String" },
  { key: "pass_defense_1_player_id", type: "String" },
  { key: "play", type: "Double" },
  { key: "fumble_recovery_1_player_name", type: "String" },
  { key: "rush_attempt", type: "Double" },
  { key: "posteam_score", type: "Long" },
  { key: "extra_point_prob", type: "Double" },
  { key: "was_pressure", type: "Boolean" },
  { key: "assist_tackle_4_player_name", type: "String" },
  { key: "fourth_down_failed", type: "Double" },
  { key: "air_yards", type: "Long" },
  { key: "opp_safety_prob", type: "Double" },
  { key: "order_sequence", type: "Double" },
  { key: "drive_first_downs", type: "Long" },
  { key: "extra_point_result", type: "String" },
  { key: "goal_to_go", type: "Boolean" },
  { key: "tackle_with_assist_1_player_name", type: "String" },
  { key: "comp_air_wpa", type: "Double" },
  { key: "defensive_two_point_conv", type: "Double" },
  { key: "interception", type: "Double" },
  { key: "lateral_kickoff_returner_player_id", type: "String" },
  { key: "two_point_attempt", type: "Double" },
  { key: "desc", type: "String" },
  { key: "qb_hit_2_player_id", type: "String" },
  { key: "away_timeouts_remaining", type: "Long" },
  { key: "home_wp", type: "Double" },
  { key: "home_opening_kickoff", type: "Double" },
  { key: "tackle_with_assist_1_player_id", type: "String" },
  { key: "td_team", type: "String" },
  { key: "play_type", type: "String" },
  { key: "vegas_home_wp", type: "Double" },
  { key: "drive_game_clock_start", type: "String" },
  { key: "fourth_down_converted", type: "Double" },
  { key: "two_point_conversion_prob", type: "Double" },
  { key: "quarter_seconds_remaining", type: "Long" },
  { key: "def_wp", type: "Double" },
  { key: "total_home_rush_wpa", type: "Double" },
  { key: "interception_player_id", type: "String" },
  { key: "forced_fumble_player_1_player_name", type: "String" },
  { key: "own_kickoff_recovery_player_id", type: "String" },
  { key: "total_home_comp_yac_epa", type: "Double" },
  { key: "total_away_comp_yac_epa", type: "Double" },
  { key: "wind", type: "String" },
  { key: "away_team", type: "String" },
  { key: "temp", type: "String" },
  { key: "sack_player_name", type: "String" },
  { key: "posteam_score_post", type: "Long" },
  { key: "total_home_raw_yac_epa", type: "Double" },
  { key: "safety_player_name", type: "String" },
  { key: "lateral_interception_player_name", type: "String" },
  { key: "score_differential", type: "Long" },
  { key: "drive_ended_with_score", type: "Double" },
  { key: "assist_tackle_2_player_name", type: "String" },
  { key: "lateral_receiver_player_id", type: "String" },
  { key: "qb_scramble", type: "Double" },
  { key: "kickoff_in_endzone", type: "Double" },
  { key: "pass_defense_2_player_name", type: "String" },
  { key: "drive_game_clock_end", type: "String" },
  { key: "vegas_home_wpa", type: "Double" },
  { key: "ydstogo", type: "Long" },
  { key: "n_defense", type: "Double" },
  { key: "game_date", type: "DateTime" },
  { key: "qb_hit_2_player_name", type: "String" },
  { key: "solo_tackle_1_player_id", type: "String" },
  { key: "punt_returner_player_name", type: "String" },
  { key: "kickoff_returner_player_name", type: "String" },
  { key: "ydsnet", type: "Long" },
  { key: "series_result", type: "String" },
  { key: "no_score_prob", type: "Double" },
  { key: "home_timeouts_remaining", type: "Long" },
  { key: "away_wp", type: "Double" },
  { key: "total_home_raw_yac_wpa", type: "Double" },
  { key: "receiver_id", type: "String" },
  { key: "safety", type: "Double" },
  { key: "qb_epa", type: "Double" },
  { key: "shotgun", type: "Double" },
  { key: "first_down_rush", type: "Double" },
  { key: "nfl_api_id", type: "String" },
  { key: "drive_end_transition", type: "String" },
  { key: "passer_jersey_number", type: "Long" },
  { key: "forced_fumble_player_1_player_id", type: "String" },
  { key: "defense_players", type: "String" },
  { key: "field_goal_attempt", type: "Double" },
  { key: "ep", type: "Double" },
  { key: "solo_tackle_2_team", type: "String" },
  { key: "drive_start_yard_line", type: "String" },
  { key: "return_team", type: "String" },
  { key: "away_wp_post", type: "Double" },
  { key: "penalty_team", type: "String" },
  { key: "jersey_number", type: "Long" },
  { key: "fantasy_player_name", type: "String" },
  { key: "offense_formation", type: "String" },
  { key: "total_home_raw_air_wpa", type: "Double" },
  { key: "rush_touchdown", type: "Double" },
  { key: "number_of_pass_rushers", type: "Double" },
  { key: "timeout_team", type: "String" },
  { key: "score_differential_post", type: "Long" },
  { key: "incomplete_pass", type: "Double" },
  { key: "pass_touchdown", type: "Double" },
  { key: "total_home_pass_wpa", type: "String" },
  { key: "td_prob", type: "Double" },
  { key: "rusher_id", type: "String" },
  { key: "fumble_recovery_2_player_id", type: "String" },
  { key: "game_stadium", type: "String" },
  { key: "td_player_id", type: "String" },
  { key: "rush", type: "Double" },
  { key: "cpoe", type: "Double" },
  { key: "replay_or_challenge", type: "String" },
  { key: "aborted_play", type: "Double" },
  { key: "play_clock", type: "String" },
  { key: "defteam", type: "String" },
  { key: "defteam_score", type: "Long" },
  { key: "defensive_extra_point_attempt", type: "Double" },
  { key: "drive_inside20", type: "Double" },
  { key: "cp", type: "Double" },
  { key: "total_home_comp_air_epa", type: "Double" },
  { key: "game_id", type: "String" },
  { key: "punt_in_endzone", type: "Double" },
  { key: "qb_kneel", type: "Double" },
  { key: "assist_tackle_2_player_id", type: "String" },
  { key: "total_away_rush_epa", type: "Double" },
  { key: "drive_play_id_started", type: "Long" },
  { key: "receiver", type: "String" },
  { key: "lateral_rushing_yards", type: "Long" },
  { key: "receiver_player_name", type: "String" },
  { key: "fumbled_2_player_name", type: "String" },
  { key: "comp_yac_epa", type: "Double" },
  { key: "fixed_drive_result", type: "String" },
  { key: "fumble_recovery_1_yards", type: "Long" },
  { key: "home_wp_post", type: "Double" },
  { key: "out_of_bounds", type: "Double" },
  { key: "drive_play_id_ended", type: "Long" },
  { key: "fumbled_1_player_name", type: "String" },
  { key: "punt_returner_player_id", type: "String" },
  { key: "total_away_comp_yac_wpa", type: "Double" },
  { key: "lateral_receiving_yards", type: "Long" },
  { key: "total_away_pass_epa", type: "Double" },
  { key: "fumble_lost", type: "Double" },
  { key: "forced_fumble_player_2_team", type: "String" },
  { key: "qb_spike", type: "Double" },
  { key: "qtr", type: "Long" },
  { key: "kickoff_out_of_bounds", type: "Double" },
  { key: "drive_time_of_possession", type: "String" },
  { key: "fg_prob", type: "Double" },
  { key: "xyac_success", type: "Double" },
  { key: "touchback", type: "Double" },
  { key: "penalty_player_id", type: "String" },
  { key: "fumble_out_of_bounds", type: "Double" },
  { key: "complete_pass", type: "Double" },
  { key: "div_game", type: "Boolean" },
  { key: "total_home_raw_air_epa", type: "Double" },
  { key: "lateral_interception_player_id", type: "String" },
  { key: "sack", type: "Double" },
  { key: "third_down_converted", type: "Double" },
  { key: "forced_fumble_player_2_player_name", type: "String" },
  { key: "posteam_type", type: "String" },
  { key: "defense_man_zone_type", type: "String" },
  { key: "total_away_rush_wpa", type: "Double" },
  { key: "stadium_id", type: "String" },
  { key: "xyac_epa", type: "Double" },
  { key: "punt_attempt", type: "Double" },
  { key: "old_game_id", type: "Long" },
  { key: "lateral_reception", type: "Double" },
  { key: "pass_location", type: "String" },];
export interface PlayProperties {
  season: number;
  week: number;
  season_type: string;
  passing_yards: number;
  rushing_yards: number;
  vegas_wpa: number;
  time: string;
  comp_air_epa: number;
  tackle_with_assist: number;
  offense_players: string;
  away_score: number;
  fumble_not_forced: number;
  old_game_id_x: number;
  game_half: string;
  assist_tackle: number;
  total_away_raw_yac_epa: number;
  tackle_for_loss_1_player_id: string;
  qb_hit: number;
  assist_tackle_1_player_name: string;
  assist_tackle_3_player_name: string;
  fumble_recovery_2_yards: number;
  two_point_conv_result: string;
  sp: number;
  defensive_extra_point_conv: number;
  receiver_jersey_number: number;
  touchdown: number;
  total_home_rush_epa: number;
  home_coach: string;
  total_away_pass_wpa: string;
  total_away_raw_air_wpa: number;
  solo_tackle_2_player_name: string;
  drive_yards_penalized: number;
  punt_fair_catch: number;
  play_id: number;
  rusher_jersey_number: number;
  opp_fg_prob: number;
  half_sack_1_player_id: string;
  time_to_throw: number;
  assist_tackle_4_team: string;
  tackled_for_loss: number;
  total_home_pass_epa: number;
  drive_quarter_start: number;
  drive_quarter_end: number;
  kickoff_attempt: number;
  punt_downed: number;
  players_on_play: string;
  down: number;
  total_home_score: number;
  receiver_player_id: string;
  total_away_raw_yac_wpa: number;
  half_sack_2_player_name: string;
  punt_inside_twenty: number;
  play_type_nfl: string;
  timeout: number;
  fumble_recovery_1_player_id: string;
  total_away_comp_air_epa: number;
  total_away_epa: number;
  pass_oe: number;
  rusher: string;
  return_touchdown: number;
  series: number;
  drive_play_count: number;
  solo_tackle_1_team: string;
  punter_player_name: string;
  air_wpa: number;
  qb_dropback: number;
  fixed_drive: number;
  ngs_air_yards: number;
  lateral_recovery: number;
  no_huddle: number;
  tackle_for_loss_1_player_name: string;
  fantasy_player_id: string;
  fumble_recovery_2_player_name: string;
  assist_tackle_1_team: string;
  penalty_player_name: string;
  fumbled_1_team: string;
  blocked_player_id: string;
  roof: string;
  yac_wpa: number;
  kicker_player_name: string;
  fumble: number;
  home_team: string;
  solo_tackle: number;
  offense_personnel: string;
  assist_tackle_3_player_id: string;
  total: number;
  xyac_fd: number;
  half_seconds_remaining: number;
  kick_distance: number;
  punt_out_of_bounds: number;
  fumble_forced: number;
  defensive_two_point_attempt: number;
  pass_defense_2_player_id: string;
  solo_tackle_1_player_name: string;
  penalty: number;
  name_player_gsis_id: string;
  old_game_id_y: number;
  replay_or_challenge_result: string;
  rusher_player_id: string;
  yards_gained: number;
  total_home_epa: number;
  total_home_comp_yac_wpa: number;
  total_home_comp_air_wpa: number;
  comp_yac_wpa: number;
  name: string;
  forced_fumble_player_2_player_id: string;
  punt_blocked: number;
  xyac_median_yardage: number;
  run_gap: string;
  extra_point_attempt: number;
  fumble_recovery_2_team: string;
  receiving_yards: number;
  kickoff_downed: number;
  forced_fumble_player_1_team: string;
  total_line: number;
  kickoff_returner_player_id: string;
  posteam_timeouts_remaining: number;
  kicker_player_id: string;
  passer_player_id: string;
  safety_player_id: string;
  run_location: string;
  lateral_receiver_player_name: string;
  first_down_penalty: number;
  id: string;
  own_kickoff_recovery_player_name: string;
  series_success: number;
  first_down: number;
  half_sack_2_player_id: string;
  possession_team: string;
  punter_player_id: string;
  penalty_yards: number;
  rusher_player_name: string;
  fantasy_id: string;
  yac_epa: number;
  fumbled_1_player_id: string;
  home_score: number;
  own_kickoff_recovery: number;
  posteam: string;
  quarter_end: number;
  total_away_score: number;
  away_coach: string;
  pass: number;
  air_epa: number;
  end_clock_time: string;
  lateral_rusher_player_name: string;
  result: number;
  penalty_type: string;
  passer_id: string;
  third_down_failed: number;
  qb_hit_1_player_id: string;
  wp: number;
  location: string;
  td_player_name: string;
  success: number;
  sack_player_id: string;
  game_seconds_remaining: number;
  nflverse_game_id: string;
  total_away_raw_air_epa: number;
  safety_prob: string;
  pass_attempt: number;
  return_yards: number;
  opp_td_prob: number;
  fumbled_2_team: string;
  qb_hit_1_player_name: string;
  surface: string;
  wpa: number;
  tackle_with_assist_1_team: string;
  defteam_timeouts_remaining: number;
  lateral_return: number;
  route: string;
  play_deleted: number;
  yardline_100: number;
  vegas_wp: number;
  xpass: number;
  field_goal_result: string;
  solo_tackle_2_player_id: string;
  total_away_comp_air_wpa: number;
  first_down_pass: number;
  own_kickoff_recovery_td: number;
  drive: number;
  defenders_in_box: number;
  assist_tackle_3_team: string;
  special: number;
  kickoff_inside_twenty: number;
  fumbled_2_player_id: string;
  defense_personnel: string;
  special_teams_play: number;
  defense_coverage_type: string;
  stadium: string;
  lateral_rusher_player_id: string;
  assist_tackle_4_player_id: string;
  passer_player_name: string;
  drive_real_start_time: string;
  pass_defense_1_player_name: string;
  time_of_day: string;
  yrdln: string;
  blocked_player_name: string;
  drive_start_transition: string;
  n_offense: number;
  drive_end_yard_line: string;
  half_sack_1_player_name: string;
  lateral_kickoff_returner_player_name: string;
  interception_player_name: string;
  assist_tackle_1_player_id: string;
  assist_tackle_2_team: string;
  yards_after_catch: number;
  fantasy: string;
  weather: string;
  side_of_field: string;
  lateral_rush: number;
  passer: string;
  spread_line: number;
  kickoff_fair_catch: number;
  fumble_recovery_1_team: string;
  epa: number;
  pass_length: string;
  xyac_mean_yardage: number;
  defteam_score_post: number;
  start_time: string;
  pass_defense_1_player_id: string;
  play: number;
  fumble_recovery_1_player_name: string;
  rush_attempt: number;
  posteam_score: number;
  extra_point_prob: number;
  was_pressure: boolean;
  assist_tackle_4_player_name: string;
  fourth_down_failed: number;
  air_yards: number;
  opp_safety_prob: number;
  order_sequence: number;
  drive_first_downs: number;
  extra_point_result: string;
  goal_to_go: boolean;
  tackle_with_assist_1_player_name: string;
  comp_air_wpa: number;
  defensive_two_point_conv: number;
  interception: number;
  lateral_kickoff_returner_player_id: string;
  two_point_attempt: number;
  desc: string;
  qb_hit_2_player_id: string;
  away_timeouts_remaining: number;
  home_wp: number;
  home_opening_kickoff: number;
  tackle_with_assist_1_player_id: string;
  td_team: string;
  play_type: string;
  vegas_home_wp: number;
  drive_game_clock_start: string;
  fourth_down_converted: number;
  two_point_conversion_prob: number;
  quarter_seconds_remaining: number;
  def_wp: number;
  total_home_rush_wpa: number;
  interception_player_id: string;
  forced_fumble_player_1_player_name: string;
  own_kickoff_recovery_player_id: string;
  total_home_comp_yac_epa: number;
  total_away_comp_yac_epa: number;
  wind: string;
  away_team: string;
  temp: string;
  sack_player_name: string;
  posteam_score_post: number;
  total_home_raw_yac_epa: number;
  safety_player_name: string;
  lateral_interception_player_name: string;
  score_differential: number;
  drive_ended_with_score: number;
  assist_tackle_2_player_name: string;
  lateral_receiver_player_id: string;
  qb_scramble: number;
  kickoff_in_endzone: number;
  pass_defense_2_player_name: string;
  drive_game_clock_end: string;
  vegas_home_wpa: number;
  ydstogo: number;
  n_defense: number;
  game_date: string;
  qb_hit_2_player_name: string;
  solo_tackle_1_player_id: string;
  punt_returner_player_name: string;
  kickoff_returner_player_name: string;
  ydsnet: number;
  series_result: string;
  no_score_prob: number;
  home_timeouts_remaining: number;
  away_wp: number;
  total_home_raw_yac_wpa: number;
  receiver_id: string;
  safety: number;
  qb_epa: number;
  shotgun: number;
  first_down_rush: number;
  nfl_api_id: string;
  drive_end_transition: string;
  passer_jersey_number: number;
  forced_fumble_player_1_player_id: string;
  defense_players: string;
  field_goal_attempt: number;
  ep: number;
  solo_tackle_2_team: string;
  drive_start_yard_line: string;
  return_team: string;
  away_wp_post: number;
  penalty_team: string;
  jersey_number: number;
  fantasy_player_name: string;
  offense_formation: string;
  total_home_raw_air_wpa: number;
  rush_touchdown: number;
  number_of_pass_rushers: number;
  timeout_team: string;
  score_differential_post: number;
  incomplete_pass: number;
  pass_touchdown: number;
  total_home_pass_wpa: string;
  td_prob: number;
  rusher_id: string;
  fumble_recovery_2_player_id: string;
  game_stadium: string;
  td_player_id: string;
  rush: number;
  cpoe: number;
  replay_or_challenge: string;
  aborted_play: number;
  play_clock: string;
  defteam: string;
  defteam_score: number;
  defensive_extra_point_attempt: number;
  drive_inside20: number;
  cp: number;
  total_home_comp_air_epa: number;
  game_id: string;
  punt_in_endzone: number;
  qb_kneel: number;
  assist_tackle_2_player_id: string;
  total_away_rush_epa: number;
  drive_play_id_started: number;
  receiver: string;
  lateral_rushing_yards: number;
  receiver_player_name: string;
  fumbled_2_player_name: string;
  comp_yac_epa: number;
  fixed_drive_result: string;
  fumble_recovery_1_yards: number;
  home_wp_post: number;
  out_of_bounds: number;
  drive_play_id_ended: number;
  fumbled_1_player_name: string;
  punt_returner_player_id: string;
  total_away_comp_yac_wpa: number;
  lateral_receiving_yards: number;
  total_away_pass_epa: number;
  fumble_lost: number;
  forced_fumble_player_2_team: string;
  qb_spike: number;
  qtr: number;
  kickoff_out_of_bounds: number;
  drive_time_of_possession: string;
  fg_prob: number;
  xyac_success: number;
  touchback: number;
  penalty_player_id: string;
  fumble_out_of_bounds: number;
  complete_pass: number;
  div_game: boolean;
  total_home_raw_air_epa: number;
  lateral_interception_player_id: string;
  sack: number;
  third_down_converted: number;
  forced_fumble_player_2_player_name: string;
  posteam_type: string;
  defense_man_zone_type: string;
  total_away_rush_wpa: number;
  stadium_id: string;
  xyac_epa: number;
  punt_attempt: number;
  old_game_id: number;
  lateral_reception: number;
  pass_location: string;
}